import React from "react";

import { Box, Text } from "@mantine/core";

interface SelectDropdownLabelSectionProps {
  children: string;
}

export function SelectDropdownLabelSection({
  children,
}: SelectDropdownLabelSectionProps): JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        background: "var(--mantine-color-gray-2)",
        border: `1px solid var(--mantine-color-gray-3)`,
        borderRight: "none",
        borderTopLeftRadius: "4px",
        borderBottomLeftRadius: "4px",
        padding: "2px 10px",
        flexGrow: 0,

        "@media(max-width: var(--mantine-breakpoint-sm))": {
          width: "90px",
          textAlign: "center",
        },
      }}
    >
      <Text
        lineClamp={1}
        size="sm"
        sx={{
          alignSelf: "center",
          fontWeight: 200,
          color: "var(--mantine-color-gray-5)",
          width: "100%",
        }}
      >
        {children}
      </Text>
    </Box>
  );
}
